import { Link, useForm } from '@inertiajs/react'
import Seo from '../../components/Seo'
import { useShared } from '../../lib/hooks'

export default function ForgotPassword() {
  const { errors } = useShared()
  const form = useForm({ user: { email: '' } })

  function submit(e: React.FormEvent) {
    e.preventDefault()
    form.post('/password')
  }

  return (
    <>
      <Seo title="Reset password" noindex />
      <div className="mx-auto max-w-md px-4 sm:px-6 py-16">
        <div className="mono-label mb-3">Account</div>
        <h1 className="text-3xl font-semibold tracking-tight">Reset your password</h1>
        <p className="mt-2 text-muted text-sm">
          Enter your email and we'll send you a link to set a new password.
        </p>

        {errors?.email && (
          <div className="mt-6 rounded-md border border-red-500/40 bg-red-500/10 text-red-300 px-4 py-2.5 text-sm">
            {errors.email}
          </div>
        )}

        <form onSubmit={submit} className="mt-6 space-y-4">
          <label className="block">
            <span className="mono-label">Email</span>
            <input
              type="email"
              autoComplete="email"
              required
              value={form.data.user.email}
              onChange={(e) => form.setData('user', { email: e.target.value })}
              className="mt-1.5 w-full h-12 bg-ink-soft border border-line focus:border-paper outline-none px-3.5 text-paper transition-colors"
            />
          </label>

          <button
            type="submit"
            disabled={form.processing}
            className="w-full h-12 bg-paper text-ink text-sm font-semibold hover:opacity-90 transition disabled:opacity-60"
          >
            {form.processing ? 'Sending…' : 'Send reset link'}
          </button>
        </form>

        <p className="mt-6 text-sm text-muted">
          Remembered it?{' '}
          <Link href="/login" className="text-paper hover:underline">Back to sign in</Link>
        </p>
      </div>
    </>
  )
}
